/* OrbitaClick · Botón "Comprar ya" · añade al carrito y va directo al checkout · 27-08-2026 */
(function () {
  'use strict';
  if (window.location.pathname.indexOf('/products/') === -1) return;

  var LABEL = 'Comprar ya';
  var SUB = 'Te llevamos directo al pago';
  var pending = false;

  // En la ficha hay muchos formularios /cart/add (tarjetas de recomendados,
  // financiación, sticky bar). Nos quedamos con el de la sección principal
  // y exigimos que tenga variante Y botón de envío.
  function findForm() {
    var scopes = [];
    var main = document.querySelector('[id*="main-product"]');
    if (main) scopes.push(main);
    var m = document.querySelector('main');
    if (m) scopes.push(m);
    for (var s = 0; s < scopes.length; s++) {
      var forms = scopes[s].querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        var f = forms[i];
        if (f.querySelector('[name="id"]') && f.querySelector('[type="submit"]')) return f;
      }
    }
    return null;
  }

  function build(form) {
    if (form.querySelector('.oc-buynow')) return;

    var atc = form.querySelector('[type="submit"][name="add"]')
           || form.querySelector('button[type="submit"]')
           || form.querySelector('[type="submit"]');
    if (!atc) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oc-buynow';
    btn.textContent = LABEL;
    btn.setAttribute('aria-label', LABEL + '. ' + SUB);

    var sub = document.createElement('small');
    sub.className = 'oc-buynow__sub';
    sub.textContent = SUB;

    var err = document.createElement('p');
    err.className = 'oc-buynow__err';
    err.setAttribute('role', 'alert');
    err.hidden = true;

    var anchor = atc.parentNode;
    anchor.insertBefore(btn, atc.nextSibling);
    anchor.insertBefore(sub, btn.nextSibling);
    anchor.insertBefore(err, sub.nextSibling);

    if (atc.disabled) { btn.disabled = true; btn.textContent = 'No disponible'; }

    btn.addEventListener('click', function () {
      err.hidden = true;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Un momento…';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () { window.location.assign('/checkout'); })
        .catch(function (e) {
          btn.disabled = false;
          btn.textContent = original;
          err.hidden = false;
          err.textContent = (e && (e.description || e.message))
            ? (e.description || e.message)
            : 'No hemos podido continuar. Inténtalo de nuevo o usa «Añadir a la cesta».';
        });
    });
  }

  function init() {
    var form = findForm();
    if (form) build(form);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      pending = false;
      init();
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // El theme re-renderiza el formulario al cambiar de variante: reinyectamos.
  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
